import can from 'can';
import Swiper from 'swiper';
import {usgaUtils} from '../../js/usga.utils';
import {LeaderBoardBaseControl} from '../leaderboard-base/leaderboard-base'
import {LeaderBoardPlayer} from '../leaderboard-contestant/leaderboard-contestant-model';
import {LeaderBoardMatch} from '../leaderboard-match-play/leaderboard-match-model';
import leaderboardTickerTables from './leaderboard-ticker-tables.stache';
import $ from "jquery";

export const LeaderboardTickerContentControl = LeaderBoardBaseControl.extend({

    updateInitialized: false,
    suspended: false,
    currentTemplate: null,
    sliderOptions: {
        slidesPerView: 'auto',
        spaceBetween: 0
    },
    init: function() {
        this._super();
		this.updateIntervalDuration = this.tickerUpdateIntervalDuration;
        this.context = this.options.context;
        this.config = this.options.leaderBoardConfig;
        this.dataUrl = this.config.dataUrl;
        this.context.attr('buttonLink', this.config.pageLink);
        this.context.attr('buttonLinkTarget', this.config.newWindow ? '_blank' : '_self');
        this.context.attr('lbType', this.config.type);
        this.render();
    },
    render: function() {
		this.element.append(leaderboardTickerTables(this.context, this.getHelpers()));
        this.getData();
    },
    destroy: function() {
        this.element.empty();
        this._super();
    },
	destroyOnExpiredLiveEvents: function () {
		const now = usgaUtils.getMomentInNewYorkTimezone().valueOf(),
			endDate = usgaUtils.getMomentInNewYorkTimezone(this.config.endDate).valueOf(),
			startDate = usgaUtils.getMomentInNewYorkTimezone(this.config.startDate).valueOf();

		if ((startDate <= now && now < endDate) === false) {
			this.destroy();
		}
	},
    handleError: function(xhr) {
        window.setTimeout(this.proxy(function(){
            this.getData();
        }), this.updateIntervalDuration);
    },
    getHelpers: function() {
        return {
            matchPlayerName: function(name) {
                name = can.isFunction(name) ? name() : name;
                if (name) {
                    return name.replace(/([A-z\-]*),\s*([A-z\-\.])*/, '$2. $1');
                }
                return null;
            },
            teamPlayerName: function(name) {
                name = can.isFunction(name) ? name() : name;
                if (name) {
                    return name.replace(/([A-z\.-]*),\s*([A-Z]{1})[A-z\.-]*\s*(\/)\s*([A-z\.-]*),\s*([A-Z]{1})[A-z\.-]*/, '$2. $1 $3 $5. $4');
                }
                return null;
            },
			renderStanding: function(match) {
				match = can.isFunction(match) ? match() : match;
            	if (match.standing) {
					match.standing = match.standing.replace('AS', 'TIED');
				}
				const isInProgress = match.attr('isInProgress');
				if (isInProgress) {
					let standing = match.standing.split(/(?=thru)/g);
					if (standing.length === 2) {
						return $('<div>' + standing[0].trim() + '</div><div class="thru">' + standing[1].trim() + '</div>');
					} else {
						return match.standing;
					}
				} else {
					return match.standing;
				}
			},
            renderArrow: function(match) {
                match = can.isFunction(match) ? match() : match;
				const isCompleted = match.attr('isCompleted');
				const leader = match.attr('leader');

				if (leader == 1) {
					if (isCompleted) {
						return 'arrow-up arrow-completed';
					} else {
						return 'arrow-up arrow-process'
					}
				} else if (leader == 2) {
					if (isCompleted) {
						return 'arrow-down arrow-completed';
					} else {
						return 'arrow-down arrow-process'
					}
				}
            },
			parColor: function(attr) {
				attr = can.isFunction(attr) ? attr() : attr;
				if (attr && parseInt(attr) < 0) {
					return 'red';
				}
				return null;
			}
        };
    },
    applyInitialContextData: function(data) {
        try {
            can.batch.start(this.proxy(function() {
                if (lbData && !lbData.suspended && this.config.type != 'cup') {
                    this.initSlider(this.element, this.sliderOptions);
                }
                if (!this.updateInitialized) {
                    this.initDataUpdating();
                    this.updateInitialized = true;
                }
            }));
            var lbData = this.checkData(data);
            this.suspended = lbData.suspended;
            this.context.attr('suspended', lbData.suspended);
			this.adjustNavigation();

            this.context.attr('isLive', this.checkIsLive());
        } catch (error) {
            console.log(error);
        }
        can.batch.stop();
    },
	adjustNavigation: function () {
		const isSuspended = this.context.attr('suspended');
		let navigation = $('.m-navigation');
		let navigationPlaceholder = $('.m-navigation-placeholder');
		if (isSuspended) {
			navigation.addClass('m-navigation--suspended');
			navigationPlaceholder.addClass('m-navigation-placeholder--suspended');
		} else {
			navigation.removeClass('m-navigation--suspended');
			navigationPlaceholder.removeClass('m-navigation-placeholder--suspended');
		}
	},
    applyDataChanges: function(data) {
        this.applyInitialContextData(data);
    },
    checkIsLive: function() {
		const now = new Date().valueOf();
		const endDate = this.config.endDate;
		const startDate = this.config.startDate;
		return (startDate <= now && endDate >= now);
    },
    checkData: function(data) {
		let rawData;
		const tableData = {};
		switch (this.config.type) {
            case 'fourball':
                rawData = data.event.tournament;
                break;
            case 'state':
                if (data.teams) {
                    rawData = data.teams;
                } else if (data.players) {
                    rawData = data.players;
                }
                break;
            case 'cup':
                rawData = data.event.tournament;
                break;
            case 'open':
                rawData = data.players;
                break;
            case 'amateur':
                rawData = data.event.tournament;
                break;
        }
        tableData.suspended = this.getPlaySuspended(rawData.playsuspended);
        tableData.items = this.getItems(rawData);
        return tableData;
    },
    getItems: function(data) {
		let tableType;
		switch (this.config.type) {
            case 'fourball':
                if (data.display.phase == 'matchplay') {
                    tableType = 'match';
                    this.applyContextItems(data.matchplay.matches.match, 'match');
                } else if (data.display.phase == 'strokeplay') {
                    this.applyContextItems(data.strokeplay.teams.team, 'player');
                    tableType = 'stroke';
                }
                break;
            case 'amateur':
                if (data.display.phase == 'matchplay') {
                    tableType = 'match';
					this.applyContextItems(data.matchplay.matches.match, 'match');
                } else if (data.display.phase == 'strokeplay') {
                    this.applyContextItems(data.strokeplay.players.player, 'player');
                    tableType = 'stroke';
                }
                break;
            case 'cup':
                this.applyCupItems(data);
                tableType = 'cup';
                break;
            case 'open':
                this.applyContextItems(data.player, 'player');
                tableType = 'stroke';
                break;
            case 'state':
                if (data.player) {
                    this.applyContextItems(data.player, 'player');
                } else if (data.team) {
                    this.applyContextItems(data.team, 'player');
                }
                tableType = 'stroke';
                break;
        }
        this.context.attr('tableType', tableType);
    },
    applyContextItems: function(items, itemType) {
        if (items && !can.isArray(items)) {
            items = [items];
        }
        this.context.items.splice(0);
		for (let i = 0, ii = items.length; i < ii; i++) {
			const itemData = items[i];
			let item;
			if (itemType == 'player') {
                item = new LeaderBoardPlayer(itemData);
            } else if (itemType == 'match') {
                item = new LeaderBoardMatch(itemData);
            }
            item.attr('lbType', this.config.type);
            this.context.items.push(item);
        }
    },
    applyCupItems: function(data) {
		const itemsData = data.cupteams;
		this.context.items.splice(0);
        this.context.items.push({
            teamOneName: itemsData.teamOneName,
            teamOnePoints: itemsData.teamOnePoints,
            teamOneAbbr: itemsData.cupteam[0].name,
            teamOneFlag: itemsData.cupteam[0].flag,
            teamTwoName: itemsData.teamTwoName,
            teamTwoPoints: itemsData.teamTwoPoints,
            teamTwoAbbr: itemsData.cupteam[1].name,
			teamTwoFlag: itemsData.cupteam[1].flag,
        });
    },
    initSlider: function (element, options) {
		this.slider = new Swiper($('.swiper-container', element), options);
    },
	onDataUpdated: function () {
		this.destroyOnExpiredLiveEvents();
	}
});
